/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { observer } from 'mobx-react-lite';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { useAppRouterStore } from '../../hooks';
import { AppRouterItem } from '../AppRouterItem';
import { AppRedirect } from '../AppRedirect';

export const AppRouterContent: React.FC<{}> = observer(() => {
    const routerStore = useAppRouterStore();

    return (
        <Routes>
            {routerStore.routes.map(AppRouterItem(''))}

            {routerStore.routes[routerStore.routes.length - 1].path !== '*' && (
                <Route
                    key={'lastPath'}
                    path={'*'}
                    element={(
                        <AppRedirect
                            currentLevelPath={''}
                            redirectTo={routerStore.routes[0].path}
                        />
                    )}
                />
            )}
        </Routes>
    );
});
